import React from "react";

export const FISCAL_YEAR_END_PICKER_LABEL =
  "Sélectionnez le mois de clôture de l'exercice en cours";

export const renderFiscalYearEndPickerPanel = (panel) => (
  <div className="period-affichee-fiscal-panel">
    <p className="period-affichee-fiscal-panel__title period-affichee-calendar-label">
      {FISCAL_YEAR_END_PICKER_LABEL}
    </p>
    {panel}
  </div>
);
